import { render, staticRenderFns } from "./RealityCurrencyHeader.vue?vue&type=template&id=4aab2834&scoped=true"
import script from "./RealityCurrencyHeader.vue?vue&type=script&lang=js"
export * from "./RealityCurrencyHeader.vue?vue&type=script&lang=js"
import style0 from "./RealityCurrencyHeader.vue?vue&type=style&index=0&id=4aab2834&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aab2834",
  null
  
)

export default component.exports